import React from 'react'
import {useDroppable} from '@dnd-kit/core'
import {SortableContext, verticalListSortingStrategy} from '@dnd-kit/sortable'
import CardItem from '../CardItem'
import type {Action, ViewType} from '../../MesActionsListPage'

type KanbanColumnProps = {
  id: 'NOUVELLE' | 'ENCOURS' | 'TERMINEE'
  title: string
  items: Action[]
  view: ViewType
  currentUser: any
  setActions: React.Dispatch<React.SetStateAction<Action[]>>
  placeholderIndex?: number | null
  showPlaceholder?: boolean
  filters?: any
}

const KanbanColumn = ({
  id,
  title,
  items,
  view,
  filters,
  currentUser,
  setActions,
  placeholderIndex = null,
  showPlaceholder = false,
}: KanbanColumnProps) => {
  const {setNodeRef, isOver} = useDroppable({
    id,
  })

  // Construction du placeholder pour placer l'élément dans sa destination
  const renderItems = () => {
    const result: React.ReactNode[] = []

    items.forEach((item, index) => {
      if (showPlaceholder && placeholderIndex === index) {
        result.push(
          <div
            key='drag-placeholder'
            style={{
              minHeight: '80px',
              transition: 'all 150ms ease',
            }}
          />
        )
      }

      result.push(
        <CardItem
          key={item.id}
          action={item}
          currentUser={currentUser}
          view={view}
          setActions={setActions}
          filters={filters}
        />
      )
    })

    if (showPlaceholder && placeholderIndex === items.length) {
      result.push(
        <div
          key='drag-placeholder'
          style={{
            minHeight: '100px',
            transition: 'all 150ms ease',
          }}
        />
      )
    }

    return result
  }

  return (
    <div
      ref={setNodeRef}
      className={`flex-1 p-4 bg-light rounded border w-100 d-flex flex-column ${
        isOver ? 'bg-primary bg-opacity-10' : ''
      }`}
      style={{
        minHeight: '500px',
      }}
    >
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h3 className='mb-0 text-dark fw-bold'>{title}</h3>

        <span className='badge bg-light'>{items?.length || 0}</span>
      </div>

      <SortableContext
        items={items.map((item) => String(item.id))}
        strategy={verticalListSortingStrategy}
      >
        <div
          className='d-flex flex-column gap-2'
          style={{
            minHeight: items.length === 0 ? 300 : undefined,
          }}
        >
          {renderItems()}
        </div>
      </SortableContext>
    </div>
  )
}

export default KanbanColumn
